/* import { DialogService } from "primeng/dynamicdialog";

export function openDialog(dialog: DialogService, data) {



      return dialog.open(ProgressDialog, {
            modal: true,
            width: "42rem",
            breakpoints: {
                "800px": "75vw",
                "575px": "90vw"
            }
      });
} */

import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export function dialogConfig<T>(config: DynamicDialogConfig<T>): DynamicDialogConfig<T> {
  if (config.modal == undefined) config.modal = true;
  if (config.width == undefined) config.width = '42rem';
  if (config.breakpoints == undefined)
    config.breakpoints = {
      '800px': '75vw',
      '575px': '90vw',
    };

  return config;
}
